import { useApi } from './useApi'

// Fuentes "print-safe": no dependen de cargar nada externo, así la hoja se
// imprime igual sin conexión y sin depender de que el navegador del que
// imprime tenga instalada una fuente rara.
export const PRINT_FONT_OPTIONS = [
  { label: 'Predeterminada', value: '' },
  { label: 'Arial', value: 'Arial, Helvetica, sans-serif' },
  { label: 'Georgia', value: 'Georgia, "Times New Roman", serif' },
  { label: 'Times New Roman', value: '"Times New Roman", Times, serif' },
  { label: 'Verdana', value: 'Verdana, Geneva, sans-serif' },
  { label: 'Courier New', value: '"Courier New", Courier, monospace' },
]

export const DEFAULT_PRINT_THEME = {
  accentColor: '#007aff',
  noteBg: '#e3f7e8',
  noteColor: '#1e7d34',
  fontFamily: '',
  logoUrl: '',
}

export const usePrintTheme = () => {
  const api = useApi()

  const getPrintTheme = async () => {
    const result = await api.get('/api/config')
    return { ...DEFAULT_PRINT_THEME, ...(result?.printTheme || {}) }
  }

  const savePrintTheme = (printTheme) => api.put('/api/config', { printTheme })

  return { getPrintTheme, savePrintTheme }
}
